// extracted by mini-css-extract-plugin
export default {"carousel":"CommunityScreen_carousel__Ncbeb","img":"CommunityScreen_img__Yy078"};